export const TRANCHE_STATUS = {
  AVAILABLE: 'available',
  PENDING: 'pending',
  ERROR: 'error',
};

export const TRANCHE_MODE = {
  TWO: '2-tranche',
  THREE: '3-tranche',
};

export const TRANCHE_DESCRIPTIONS = {
  core: 'Snap formations, play-by-play data, tackles, pre-snap motion and freeze frames.',
  tracking: 'Positions of all 22 players throughout every play.',
  advanced:
    'Engagements, post-snap movement, pass placement and line techniques.',
};

// Maps game.t1DataOnly to 2-tranche statuses for Game Overview.
export const getStatusesFromGame = (game) => {
  if (!game) return null;
  return {
    core: TRANCHE_STATUS.AVAILABLE,
    advanced: game.t1DataOnly
      ? TRANCHE_STATUS.PENDING
      : TRANCHE_STATUS.AVAILABLE,
  };
};

const countAvailable = (mode, statuses) =>
  [
    statuses.core,
    mode === TRANCHE_MODE.THREE ? statuses.tracking : null,
    statuses.advanced,
  ].filter((status) => status === TRANCHE_STATUS.AVAILABLE).length;

const getTrancheCount = (mode) => (mode === TRANCHE_MODE.TWO ? 2 : 3);

const allAvailable = (mode, statuses) =>
  countAvailable(mode, statuses) === getTrancheCount(mode);

export const getLabel = (mode, statuses) => {
  if (allAvailable(mode, statuses)) return 'All Data';
  if (
    mode === TRANCHE_MODE.THREE &&
    statuses.core === TRANCHE_STATUS.AVAILABLE &&
    statuses.tracking === TRANCHE_STATUS.AVAILABLE
  ) {
    return 'Core + Tracking Data';
  }
  return 'Core Data';
};

export const getBadgeVariant = (mode, statuses) =>
  allAvailable(mode, statuses) ? 'success' : 'subtle';

const KNOWN_STATUSES = Object.values(TRANCHE_STATUS);

// Unknown values fall back to Pending: the panel's Icon throws on an icon
// name it does not know, which would break the whole page.
const toStatus = (status) =>
  KNOWN_STATUSES.includes(status) ? status : TRANCHE_STATUS.PENDING;

export const getTranches = (mode, statuses) => [
  {
    key: 'core',
    title: 'Core Data',
    description: TRANCHE_DESCRIPTIONS.core,
    status: toStatus(statuses.core),
  },
  ...(mode === TRANCHE_MODE.THREE
    ? [
        {
          key: 'tracking',
          title: 'Tracking Data',
          description: TRANCHE_DESCRIPTIONS.tracking,
          status: toStatus(statuses.tracking),
        },
      ]
    : []),
  {
    key: 'advanced',
    title: 'Advanced Data',
    description: TRANCHE_DESCRIPTIONS.advanced,
    status: toStatus(statuses.advanced),
  },
];

export const getAccessibleName = (mode, statuses) => {
  const label = getLabel(mode, statuses);
  const available = countAvailable(mode, statuses);
  return `Data status: ${label}, ${available} of ${getTrancheCount(mode)} tranches available`;
};
